export default {
    async logout(store, loaderTheme, callback) {
        store.dispatch('siteLoader/openForced', loaderTheme, { root: true })

        await store.dispatch('apiAuth/logout')

        store.dispatch('layout/clearLayoutClasses')

        window.localStorage.removeItem('sample')

        store.dispatch('siteLoader/closeForced')

        callback()
    }
}